<template>
    <div class="switcher">        
        <div>
            <div class="swithcMode" v-if="isInTestMode">TEST MODE: ON</div>
            <div class="swithcMode" v-else>TEST MODE: OFF</div>
            <div class="switchBtn" @click="switchMode" title="Switch mode">Switch mode</div>
        </div>
    </div>
</template>

<style scoped>
    .switcher
    {
        width: 100%;
        height: 80vh;
        display: flex;
        align-content: center;
        align-items: center;
        text-align: center;
        margin: auto;
    }
    .switcher > div
    {
        margin: auto;
    }
    .switcher .swithcMode{
        margin: auto;
        font-weight: 400 !important;
        display: inline-block;
        width: 100%;
        text-align: center;
    }
    .switchBtn
    {
        margin: auto;
        font-weight: 400 !important;
        border: solid 2px #202020;
        color: #202020;
        font-size: 15px;
        padding: 12px;
        border-radius: 50px;
        margin-top: 20px;
        cursor: pointer;

    }
    .switchBtn:hover
    {
        color: #fff;
        background: #202020;
    }
</style>

<script>
  import { mapActions, mapState } from "vuex";  
  export default 
  {
    //this component is trigger by route: /switchtest 
    //it swithes the session storage var _isTestMode

    components:
    {

    },
    data(){
      return{
        isInTestMode:false
      }
    },  
    computed: {
        //...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),
    },
    created()  
    {            
    },
    mounted()
    {
        var vm = this;
        vm.checkTestMode();
    },
    methods:
    {
      //...mapActions(["setMinisiteData","setMinisiteDic","xSetPlatform","initRouteByCid","setPageReady"]),
        checkTestMode()
        {
            let isTest = sessionStorage.getItem("_isInTestMode");
            if (isTest === null) {
                this.isInTestMode = false;
                sessionStorage.setItem("_isInTestMode", JSON.stringify(this.isInTestMode));
            } 
            else 
            {
                this.isInTestMode = JSON.parse(isTest);
            }       
        },
        switchMode()
        {
            sessionStorage.setItem("_isInTestMode", JSON.stringify(!this.isInTestMode));
            this.checkTestMode();
        }
    }
}
</script>


